import { trackEvent } from 'ddc-track-event';

const closeModalHelper = (
	widgetName,
	windowId,
	setModalIsOpen,
	setSearchTerm,
	isEmbeddedOverrideActive,
	setIsEmbeddedOverrideActive,
	isPanelMode
) => {
	if (window.DDC?.WidgetData?.[widgetName]) {
		window.DDC.WidgetData[widgetName] = {
			...window.DDC.WidgetData[widgetName],
			modalIsOpen: false
		};
	}
	setModalIsOpen(false);
	setSearchTerm('');
	if (isEmbeddedOverrideActive) {
		setIsEmbeddedOverrideActive(false);
	}
	// panel mode has no modal to close and no scroll lock of its own -- the
	// host (drawer) owns document.body.style.overflow, so touching it here
	// would clobber the host's own scroll lock (T10/PRD).
	if (!isPanelMode) {
		document.body.style.overflow = 'auto';
	}
	trackEvent(widgetName, windowId, {
		action: 'clicked',
		element: 'close button',
		result: 'search modal closed'
	});
};

export default closeModalHelper;
